<div class="table-section">
  <loading class="loading-container" [isLoading]="isLoading" ></loading>

  <div class="chart-container">

    <!-- este flota -->
    <div class="table-button" *ngIf="('Alarmas' | permissionFilter) && chartData?.datasets[0]?.data?.length > 0">
      <button>
        <span (click)="openAlarmsTable()">Ver historial</span>
      </button>
    </div>


    <div class="top">
      <h2>Alarmas por Día por Mes</h2>
    </div>

    <div class="bottom">
      <canvas class="chart" *ngIf="chartData?.datasets[0]?.data?.length > 0"
        baseChart
        [data]="chartData"
        [type]="'line'"
        [options]="chartOptions"
        (chartClick)="onChartClick($event)">
      </canvas>
    </div>

    <div class="no-result-item" *ngIf="!isLoading && (!chartData?.datasets[0]?.data?.length || chartData?.datasets[0]?.data?.length === 0)">
      <h1>No se encontraron datos</h1>
    </div>
  </div>

</div>